exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".c-menu-toggle{cursor:pointer;float:right;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;color:tomato;font-size:2.5rem;line-height:1.2;padding:0 .35rem;margin-right:-.35rem;margin-left:.7rem;width:.75em;height:1em;background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Cpath fill='tomato' d='M4 10h24a2 2 0 000-4H4a2 2 0 000 4zm24 4H4a2 2 0 000 4h24a2 2 0 000-4zm0 8H4a2 2 0 000 4h24a2 2 0 000-4z'/%3E%3C/svg%3E\") 50%/contain no-repeat}@media (min-width:60em){.c-menu-toggle{display:none}}", ""]);

// exports
